import { useQuery } from '@apollo/client';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { FETCH_WA_NUMBER, FETCH_MULTIPLE_WA_NUMBER } from './gqlQueries';
export const useFetchWANumber = ({
  objectId,
  objectTypeId
}) => {
  const query = objectTypeId === CONTACT_TYPE_ID ? FETCH_WA_NUMBER : FETCH_MULTIPLE_WA_NUMBER;
  return useQuery(query, {
    nextFetchPolicy: 'cache-first',
    variables: {
      subjectId: Number(objectId),
      objectTypeId
    }
  });
};